import { CHANNEL_OPTIONS } from '@/utils/campaignOptions'

export function sanitizeChannelProps (channel) {
  // remove .00 from props that contains numbers or strings with number values and conver to string since .00 has removed
  const props = [
    'budget',
    'max_bid',
    'target_cpa',
    'target_roas'
  ]
  props.forEach(prop => {
    if (channel[prop]) {
      channel[prop] = channel[prop].toString().replace('.00', '')
    }
  })
  return channel
}

export function getChannelBench (channel) {
  if (channel.ctrBench) {
    return channel.ctrBench
  }
  if (channel.type === CHANNEL_OPTIONS.GEOLOCATION) {
    return 0.40
  }
  if (channel.type === CHANNEL_OPTIONS.RETARGETING) {
    return 0.12
  }
  if (channel.type === CHANNEL_OPTIONS.INTEREST) {
    return 0.08
  }
  if (channel.type === CHANNEL_OPTIONS.FACEBOOK) {
    return 0.50
  }
  if (channel.type === CHANNEL_OPTIONS.INSTAGRAM) {
    return 0.50
  }
  if (channel.type === CHANNEL_OPTIONS.YOUTUBE) {
    return 0.50
  }
  if (channel.type === CHANNEL_OPTIONS.LOCALINVENTORYADS) {
    return 0
  }
  if (channel.type === CHANNEL_OPTIONS.GOOGLESEARCHADS) {
    return 23.5
  }
  if (channel.type === CHANNEL_OPTIONS.META) {
    return 0.50
  }
  if (channel.type === CHANNEL_OPTIONS.GOOGLE) {
    return 23.5
  }
  if (channel.type === CHANNEL_OPTIONS.DV360) {
    return 0.1
  }
  return 0
}
